import { COLORS } from '@avalara/bat-apps-shared/constants';
import { t } from '@avalara/bat-apps-shared/i18n';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import FormInput from '../../containers/shared/forms/form-input';
import { checkPasswordStrength } from '../../lib/side-effects/check-passwords';
import { selectState } from '../../selectors';
import { PasswordStrengthBox } from '../styled/components/password-box';

export const strongPasswordText =
  'The strongest passwords are long and contain numbers, symbols, and a mix of upper and lower case letters';

const PasswordShowButton = styled.span`
  background: transparent;
  border: 1px solid transparent;
  border-radius: 2px;
  display: block;
  font-size: .85em;
  height: auto;
  padding: 1px 5px 2px;
  position: absolute;
  top: 4px;
  right: 4px;
  color: ${COLORS.lighterMediumDarkGray};
  &:before, &:after {
    content: "";
    display: table;
    width: 100%;
    visibility: hidden;
  }
  &:hover {
    cursor: pointer;
  }
`;

type Props = {
  marginAboveError?: string;
};

const PasswordInput = ({ marginAboveError }: Props) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [strengthText, setStrengthText] = useState('Strength');
  const [strengthMeterClass, setStrengthMeterClass] = useState('Strength');

  const {
    sharedSignup: {
      signupForm: { password },
    },
  } = useSelector(selectState);

  useEffect(() => {
    checkPasswordStrength({ password: password || '', setStrengthText, setStrengthMeterClass });
  }, [password]);

  return (
    <fieldset>
      <div className='relative'>
        <FormInput
          marginAboveError={marginAboveError}
          type={isPasswordVisible ? 'text' : 'password'}
          fieldName='password'
          placeholder={t('client.placeholders.password')}
        />

        <PasswordShowButton
          tabIndex={0}
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          onKeyDown={(e: {
            which: number;
            preventDefault: () => void;
          }) => {
            if (e.which === 13) {
              e.preventDefault();
              setIsPasswordVisible(!isPasswordVisible);
            }
          }}
        >
          {isPasswordVisible ? 'hide' : 'show'}
        </PasswordShowButton>

        <PasswordStrengthBox>
          <div id='strength-meter-gauge' className={`${strengthMeterClass} form-inline strength-meter`} />
          <div id='strength-text' className={`${strengthMeterClass} strength-text`}>
            {strengthText}
          </div>
        </PasswordStrengthBox>
      </div>
    </fieldset>
  );
};

export default PasswordInput;
